import { ImageFileType } from './image-file-type';

export type FileType = 'pdf' | 'zip' | 'rar' | '7z' | 'tar' | 'tar.gz' | ImageFileType;
